import LightingIcon from '@/bundle/shared/components/banner/images/LightingIcon.svg?react';
import StripeBannerIcon from './images/StripeBannerIcon.svg?react';
import { STRIPE_LINK } from '@/const/shared';
import { StripeLink } from '@/bundle/shared/components/banner/styles';
import { Banner } from '@/components/Banner/Banner';

const BACKGROUND = 'linear-gradient(90deg, #e7e9fe 0%, #c6c5ff 100%)';

export const StripeInfoBanner = () => {
  return (
    <Banner
      background={BACKGROUND}
      icon={
        <>
          <LightingIcon />
          <StripeLink href={STRIPE_LINK} target='_blank'>
            <StripeBannerIcon />
          </StripeLink>
        </>
      }
    >
      We use Stripe to manage secure billing and subscriptions.
    </Banner>
  );
};
